<p>view-child-ina works!</p>
